import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import cn from 'classnames'

import TabOrderItems from '../TabOrderItems'
import SidebarModal from '../../SidebarModal'
import SplitOrderNumberPad from './SplitOrderNumberPad'
import useNumberPad from '../../../hooks/useNumberPad'
import Button from '../../Button'
import BackChevron from '../../BackChevron'

import styles from './SplitOrder.module.scss'
import { centsToDollars } from '../../../utils/formatters'
import { calculateGroupedItems } from '../../../utils/splitUtils'

const SplitOrderByDollar = ({ orderId, suiteInformation, orderNumber, totalInCents, groupedItems, items, onCancel, onPayNow, onKeepTabOpen, onClose }) => {
  const history = useHistory()
  const [calculatedGroupedItems, setCalculatedGroupedItems] = useState(calculateGroupedItems(groupedItems, 1))
  const [grandTotal, setGrandTotal] = useState(centsToDollars(totalInCents))
  const [showNumberPad, setShowNumberPad] = useState(true)
  const [
    output,
    onInput,
    rawValue,
    valid,
  ] = useNumberPad(
    0,
    centsToDollars,
    (value) => parseInt(value) > 0 && parseInt(value) < totalInCents,
    6,
  )

  const confirmButtonText = `Confirm ${output}`

  const handleOnConfirm = () => {
    const percentage = parseFloat(parseInt(rawValue) / totalInCents)
    const nextItems = calculateGroupedItems(groupedItems, percentage)

    setGrandTotal(output)
    setCalculatedGroupedItems(nextItems)
    setShowNumberPad(false)
  }

  const handleOnCancel = () => {
    setShowNumberPad(false)
  }

  const handleKeepTabOpen = () => {
    if (!valid) {
      toast.error('You must enter an amount to split by.', { autoClose: 2500 })
    } else {
      const selectedItemIndexes = Array.from(Array(items.length), (_, index) => index)
      const percentage = parseFloat(parseInt(rawValue) / totalInCents)

      onKeepTabOpen(selectedItemIndexes, percentage, grandTotal)
    }
  }

  const handlePayNow = () => {
    if (!valid) {
      toast.error('You must enter an amount to split by.', { autoClose: 2500 })
    } else {
      const selectedItemIndexes = Array.from(Array(items.length), (_, index) => index)
      const percentage = parseFloat(parseInt(rawValue) / totalInCents)

      onPayNow(selectedItemIndexes, percentage, grandTotal)
    }
  }

  return (
    <SidebarModal
      show
      title="Split Order"
      onClose={onClose}
      leftAccessory={<BackChevron onClick={() => history?.replace?.(`/tabs/${orderId}`)} />}
      className={styles.splitOrder}
    >
      <div className={styles.bodyContainer}>
        <div className={styles.splitOrderHeader}>
          <p>{suiteInformation?.displayName}: #{orderNumber}</p>
          <p>Grand Total: <span className={styles.subtotal}>{grandTotal}</span></p>
        </div>
        <TabOrderItems items={calculatedGroupedItems} />
        {showNumberPad && (
          <SplitOrderNumberPad
            title="Enter $ amount to split onto new order"
            value={output}
            valueAccessory={centsToDollars(totalInCents)}
            confirmButtonText={confirmButtonText}
            valid={valid}
            onInput={onInput}
            onCancel={handleOnCancel}
            onConfirm={handleOnConfirm}
          />
        )}
        <div className={styles.buttonContainer}>
          <Button className={styles.actionButton} onClick={() => setShowNumberPad(true)}>Edit</Button>
          <Button className={cn(styles.actionButton, { disabled: !valid })} onClick={handleKeepTabOpen}>Keep Tab Open</Button>
          <Button className={cn(styles.actionButton, styles.mintGreenHighlight, { disabled: !valid })} onClick={handlePayNow}>Pay Now</Button>
        </div>
      </div>
    </SidebarModal>
  )
}

export default SplitOrderByDollar
